export type Country = "aze" | "uzb";

export const DEFAULT_COUNTRY: Country = "aze";

export const COUNTRY_PHONE_PREFIXES: Record<Country, string> = {
    aze: "+994",
    uzb: "+998",
};

export const country = (process.env.REACT_APP_COUNTRY as Country) || DEFAULT_COUNTRY;

export const phonePrefix = COUNTRY_PHONE_PREFIXES[country] || COUNTRY_PHONE_PREFIXES[DEFAULT_COUNTRY];
